import { render } from "./IntroHelp.vue?vue&type=template&id=391c4ae4"
import script from "./IntroHelp.vue?vue&type=script&lang=js"
export * from "./IntroHelp.vue?vue&type=script&lang=js"

import "./IntroHelp.vue?vue&type=style&index=0&id=391c4ae4&lang=scss"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__